import React from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { push } from "react-router-redux";
import { Accessibility, Check, X } from "lucide-react";
import { withNamespaces } from "react-i18next";

import AppHeader from "../containers/AppHeader";
import NmStepBar from "../components/NmStepBar";
import { postPrebooking } from "../actions/qrs";

class AccessibilityView extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      error: null,
    };
  }

  goTo(accessibilityType) {
    if (this.state.loading) return;

    const {
      zoneSelected,
      selectedLocker,
      descriptionZone,
      qr,
      lockerPrice,
      qrType,
      qrMode,
    } = this.props.location.state;

    this.setState({ loading: true, error: null });

    const prebooking = {
      Qr: qr,
      LockerSelected: selectedLocker,
      Zone: zoneSelected,
      Accessibility: accessibilityType,
      qrMode: qrMode,
    };

    this.props
      .postPrebooking(prebooking)
      .then((answer) => {
        const {
          LockerAssigned,
          LockerPin,
          LockerMatricula,
          LockerCustomer,
          LockerCustomerID,
          LockerMatrixId,
        } = answer.response.answerPrebooking;

        this.props.push("/PhoneView", {
          selectedLocker,
          zoneSelected,
          selectedAccessibility: accessibilityType,
          descriptionZone,
          lockerAssigned: LockerAssigned,
          lockerPrice,
          lockerPin: LockerPin,
          lockerMatricula: LockerMatricula,
          lockerCustomer: LockerCustomer,
          lockerCustomerID: LockerCustomerID,
          lockerMatrixId: LockerMatrixId,
          qr,
          qrType,
          qrMode,
          timeStamp: new Date(),
        });
      })
      .catch((error) => {
        console.error(error);
        this.setState({ loading: false, error: true });
      });
  }

  render() {
    const { t } = this.props;
    const { loading, error } = this.state;

    const content = (
      <>
        <div className="nm-page-header-card">
          <div className="nm-page-header-card-text">
            <h3>{t("ACCESIBILIDAD")}</h3>
            <span className="nm-page-header-zone">
              {t("Tienes la opción de seleccionar una taquilla de altura adaptada para tu confort.")}
            </span>
          </div>
          <Accessibility className="nm-form-icon" strokeWidth={1} />
        </div>

        <div className="nm-form nm-accessibility-card">
          <img
            src="/images/disabled.svg"
            alt="Accessibility"
            className="nm-accessibility-img"
          />

          <h4 className="nm-accessibility-question">
            {t("¿NECESITAS UNA TAQUILLA ADAPTADA?")}
          </h4>

          {error && (
            <p className="nm-uf-error" style={{ textAlign: 'center', marginBottom: 12 }}>
              {t("Ha ocurrido un error. Inténtalo de nuevo.")}
            </p>
          )}

          <div className="nm-accessibility-btns">
            <button
              className={`nm-accessibility-btn-no${loading ? ' nm-btn-disabled' : ''}`}
              onClick={() => this.goTo(false)}
              disabled={loading}
            >
              <X size={20} strokeWidth={2.2} />
              <span>{t("NO")}</span>
            </button>
            <button
              className={`nm-accessibility-btn-yes${loading ? ' nm-btn-disabled' : ''}`}
              onClick={() => this.goTo(true)}
              disabled={loading}
            >
              {loading ? (
                <span className="nm-btn-spinner" />
              ) : (
                <Check size={20} strokeWidth={2.2} />
              )}
              <span>{t("SI")}</span>
            </button>
          </div>
        </div>
      </>
    );

    return (
      <div className="normalBackground">
        <AppHeader />
        <div className="nm-page smartphone">
          {content}
          <NmStepBar step={2} />
        </div>
        <div className="nm-page pc">
          {content}
          <NmStepBar step={2} />
        </div>
      </div>
    );
  }
}

const mapStateToProps = () => ({ auth: true });

const mapDispatchToProps = (dispatch) => ({
  push: bindActionCreators(push, dispatch),
  postPrebooking: bindActionCreators(postPrebooking, dispatch),
});

export default withNamespaces()(
  connect(mapStateToProps, mapDispatchToProps)(AccessibilityView)
);
